import { BaseGameState } from "@quest/murka-games-behavior-panther/dist/Game/State/BaseGameState";
import { BaseGameViewGame } from "../Base/BaseGameViewGame";
import { BaseView, dispatcher, ingenuity } from "@quest/base-core";
import { CascadingReelPanelView } from "../Base/CascadingReelPanelView";
import { CascadingReelPanelController } from "../Base/CascadingReelPanelController";
import { FreeSpinBarController } from "../Base/FreeSpinBarController";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { StackSymbolView } from "../StackSymbol/StackSymbolView";
import { StackSymbolController } from "../StackSymbol/StackSymbolController";
import { ClusterWinFrameView } from "../ClusterWinFrame/ClusterWinFrameView";
import { ClusterWinFrameController } from "../ClusterWinFrame/ClusterWinFrameController";
import { TrailView } from "../trailPanel/TrailView";
import { TrailController } from "../trailPanel/TrailController";
import { QLinePlayerMessageController } from "../Base/QLinePlayerMessageController";
import { StickyFramesContorller } from "../StickyFrames/StickyFramesContorller";
import { StickyFramesView } from "../StickyFrames/StickyFramesView";
import { investigationRoomView } from "../InvestigationRoom/InvestigationRoomView";
import { SlotConstantsBehavior } from "@quest/murka-games-behavior-panther";
import { InvestigationRoomController } from "../InvestigationRoom/InvestigationRoomController";
import { WinCollectionTrailView } from "../WinCollectionTrail/WinCollectionTrailView";
import { WinCollectionTrailController } from "../WinCollectionTrail/WinCollectionTrailController";
import { MoneyHuntingView } from "../MoneyHunting/MoneyHuntingView";
import { MoneyHuntingController } from "../MoneyHunting/MoneyHuntingController";

export class BaseGameStateGame extends BaseGameState {
  protected view: BaseGameViewGame;
  private cascadeView: BaseView;
  protected winStackSymbolView: StackSymbolView;
  protected winStackSymbolController: StackSymbolController;
  protected clusterWinFrameView: ClusterWinFrameView;
  protected clusterWinFrameController: ClusterWinFrameController;
  private trailView: BaseView;
  private stickyView:StickyFramesView;
  private moneyHuntingView:MoneyHuntingView;
  private investigationRoomView:investigationRoomView;
  private winCollectionTrailView:WinCollectionTrailView;



  protected initializeController(): void {
    super.initializeController();
    new FreeSpinBarController(this.view);
  }
  // Overrided to Initialize some features and to fire events
  public init(): void {
    super.init();
    this.initializeCascadingReelPanelController();
    this.initializeFreeSpinBarController();
    this.initQLinePlayerMessage();
    this.initializeStickyFrameController();
    this.initializeMoneyHuntingController();
    this.initializeTrailController();
    this.initializeInvestigationScreen();
  }



  private initQLinePlayerMessage(): void {
    new QLinePlayerMessageController(this.view)
  }
 // Overrided to subscribe events
  protected subscribeEventsGame(): void {
    super.subscribeEventsGame();
    dispatcher.on(eventDispatchers.INITIALIZE_WIN_COLLECTION,this.initializeWinCollection,this)
    dispatcher.on(eventDispatchers.INITIALIZE_STACK_SYMBOL_WIN, this.initializeStackSymbol, this);
    dispatcher.on(eventDispatchers.INITIALIZE_CLUSTER_WIN_FRAME, this.initializeClusterWinFrame, this);
  }
  // Overrided to un-subscribe events
  protected unSubscribeEvents(): void {
    super.unSubscribeEvents();
    dispatcher.off(eventDispatchers.INITIALIZE_WIN_COLLECTION,this.initializeWinCollection,this)
    dispatcher.off(eventDispatchers.INITIALIZE_STACK_SYMBOL_WIN, this.initializeStackSymbol, this);
    dispatcher.off(eventDispatchers.INITIALIZE_CLUSTER_WIN_FRAME, this.initializeClusterWinFrame, this);
  }

  /**
   * To initialized cascade reel view and controller
   */
  private initializeCascadingReelPanelController(): void {
    this.cascadeView = new CascadingReelPanelView(ingenuity.currentGame.cache.getJSON("main_data").cascadingReelPanel);
    this.view.addChild(this.cascadeView);
    new CascadingReelPanelController(this.view, this.cascadeView, this.model);
  }

   /**
   * This method will initialize the classes for orb/feature amt collection
   */
  private initializeWinCollection(): void {
    if (!this.winCollectionTrailView) {
      this.winCollectionTrailView = new WinCollectionTrailView(
        ingenuity.currentGame.cache.getJSON(SlotConstantsBehavior.MAIN_DATA).WinCollectionTrail
      );
      new WinCollectionTrailController(this.winCollectionTrailView);
      ingenuity.currentGame.stage.addChild(this.winCollectionTrailView);
    }
  }

  private initializeFreeSpinBarController(): void {
    new FreeSpinBarController(this.view);
  }

  // To initialize cluster win frame
  protected initializeClusterWinFrame(): void {
    if (!this.clusterWinFrameView) {
      this.clusterWinFrameView = new ClusterWinFrameView(ingenuity.currentGame.cache.getJSON("main_data").ClusterWinFrame);
      this.clusterWinFrameController = new ClusterWinFrameController(this.clusterWinFrameView, this.view);
      this.winReelpanel.addChildAt(this.clusterWinFrameView, this.winReelpanel.children.length);
    }
  }

  // Intialize stack symbol
  protected initializeStackSymbol(): void {
    if (!this.winStackSymbolView) {
      this.winStackSymbolView = new StackSymbolView(ingenuity.currentGame.cache.getJSON("main_data").stackSymbol);
      this.winStackSymbolController = new StackSymbolController(this.winStackSymbolView, this.view);
      this.setLayering(this.winStackSymbolView);
    }
  }

  //set layering below winboxes
  protected setLayering(obj: any) {
    const winBoxIndex: number = this.getWinBoxIndex();
    winBoxIndex && this.winReelpanel.addChildAt(obj, winBoxIndex);
  }
  private initializeTrailController(): void {
    this.trailView = new TrailView(ingenuity.currentGame.cache.getJSON("main_data").trailPanel);
    this.view.addChild(this.trailView);
    new TrailController(this.view,this.trailView, this.model);
  }
  
  private initializeStickyFrameController(): void {
    if(this.stickyView) return;
    this.stickyView = new StickyFramesView(ingenuity.currentGame.cache.getJSON("main_data").stickyFrameSymbol);
    this.view.addChild(this.stickyView);
    new StickyFramesContorller(this.stickyView);
  }
   private initializeMoneyHuntingController(): void {
    if(this.moneyHuntingView) return;
    this.moneyHuntingView = new MoneyHuntingView(ingenuity.currentGame.cache.getJSON("main_data").moneyHunting);
    this.view.addChild(this.moneyHuntingView);
    new MoneyHuntingController(this.moneyHuntingView);
  }
  // Add to initialize egg collection screen view
  private initializeInvestigationScreen(): void {
    if (!this.investigationRoomView) {
      this.investigationRoomView = new investigationRoomView(
        ingenuity.currentGame.cache.getJSON(SlotConstantsBehavior.MAIN_DATA).InvestigationRoom
      );
      new InvestigationRoomController(this.investigationRoomView);
    }
    ingenuity.currentGame.stage.addChild(this.investigationRoomView);
  }
}
